var _style, _g, _g2, _g3, _circle, _path, _ellipse, _ellipse2, _ellipse3, _polyline, _ellipse4, _ellipse5, _path2, _line, _path3, _ellipse6, _ellipse7, _path4, _path5, _polygon, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRealOwlLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1080px",
    height: "1080px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;fill:#6AB288;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st1{fill:none;}\r\n\t.st2{display:none;opacity:0.9686;fill:none;stroke:#000000;stroke-width:9;stroke-miterlimit:10;}\r\n\t.st3{display:none;opacity:0.9686;fill:none;stroke:#000000;stroke-width:3.5;stroke-miterlimit:10;}\r\n\t.st4{display:none;opacity:0.6314;fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st5{display:none;opacity:0.6902;fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st6{display:none;fill:none;stroke:#ED1C1C;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st7{display:none;fill:none;stroke:#000000;stroke-width:9;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#000000;stroke-width:8;stroke-miterlimit:10;}\r\n\t.st9{opacity:0.2784;fill:url(#SVGID_1_);}\r\n\t.st10{opacity:0.3216;fill:url(#SVGID_2_);}\r\n\t.st11{opacity:0.3294;fill:url(#SVGID_3_);}\r\n\t.st12{fill:none;stroke:#000000;stroke-width:15;stroke-miterlimit:10;}\r\n\t.st13{fill:#FFFFFF;}\r\n\t.st14{fill:none;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st15{display:none;fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;}\r\n\t.st16{display:none;fill:none;stroke:#000000;stroke-width:9;stroke-miterlimit:10;stroke-dasharray:0,0,0,0,0,0;}\r\n\t.st17{display:none;stroke:#000000;stroke-width:9;stroke-miterlimit:10;stroke-dasharray:0,0,0,0,0,0;}\r\n\t.st18{display:none;fill:#FFFFFF;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st19{fill:#EFEEEF;}\r\n\t.st20{opacity:0.2784;fill:url(#SVGID_4_);}\r\n\t.st21{opacity:0.3216;fill:url(#SVGID_5_);}\r\n\t.st22{opacity:0.3294;fill:url(#SVGID_6_);}\r\n\t.st23{opacity:0.251;fill:url(#SVGID_7_);}\r\n\t.st24{opacity:0.349;fill:url(#SVGID_8_);}\r\n\t.st25{stroke:#000000;stroke-width:3.5;stroke-miterlimit:10;}\r\n\t.st26{fill:none;stroke:#000000;stroke-width:3.5;stroke-miterlimit:10;}\r\n\t.st27{fill:#EBC356;stroke:#EBC356;stroke-miterlimit:10;}\r\n\t.st28{fill:#EBC356;}\r\n\t.st29{fill:#EBC356;stroke:#000000;stroke-width:7;stroke-miterlimit:10;}\r\n\t.st30{opacity:0.9686;fill:none;stroke:#000000;stroke-width:8;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Glasses"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3_face"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nose"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tie"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Head"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 540,
    cy: 540,
    r: 537.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M281.02,229.82c-33.05,2.91-27.35,68.21-21.02,103.55c5.43,30.36,50.83,72.37,30.45,83.44 c-66.75,36.27-79.66,154.67-79.66,154.67s4.92,73.19,46.67,141.65c18.98,31.12,49.98,58.86,83.13,83.79 c30.3,22.78,67.46,40.76,108.2,50.42c10.7,2.54,23.11,5.9,34.01,7.37c5.99,0.81,12.19,2.33,18.02,3.36 c65.23,11.48,134.45-7.31,183.09-28.76c120.02-52.93,181.84-139.65,181.84-259.94c0-20.97-4.29-63.57-22.78-98.9 c-11.54-22.05-58.34-46.31-41.12-62.33c7.67-7.13,39.64-30.94,47.77-43.2c7.41-11.18-22.55-0.41-20.73-9.56 c2.53-12.77,34.63-40.22,36.83-50.41c3.47-16.08-23.87,8.61-23.87-1.93c0-22.37,10.53-85.52-13.37-84.55 c-17.3,0.7-34.32,9.85-74.27,38.22c-8.98,6.38-18.73,17.75-29.64,24.21c-27.39,16.24-9.59,9.54-32.71,29.1 c-11.82,10-110.94-51.25-125.45-45.73c-11.74,4.47,49.56,38.14,37.63,41c-22.67,5.43-41.09-16.06-66.97-16.77 c-23.66-0.64-64.29-2.74-94.59,4.11c-22.23,5.03-30.73,19.22-43.87,6.93C354.73,258.51,317.13,226.65,281.02,229.82z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.7779,
    y1: 547.3616,
    x2: 521.2073,
    y2: 547.3616
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 365.99,
    cy: 547.36,
    rx: 155.21,
    ry: 161.69
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.1123,
    y1: 547.3616,
    x2: 511.6271,
    y2: 547.3616
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 363.87,
    cy: 547.36,
    rx: 147.76,
    ry: 161.69
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.1123,
    y1: 547.9243,
    x2: 520.1122,
    y2: 547.9243
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11",
    cx: 368.11,
    cy: 547.92,
    rx: 152,
    ry: 162.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 557.4643,
    y1: 552.8217,
    x2: 868.4424,
    y2: 552.8217
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCFCFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#030303"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.251,
      fill: "url(#SVGID_4_)"
    },
    cx: 712.95,
    cy: 552.82,
    rx: 155.49,
    ry: 156.26
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 557.4643,
    y1: 548.8424,
    x2: 868.4424,
    y2: 548.8424
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.349,
      fill: "url(#SVGID_5_)"
    },
    cx: 712.95,
    cy: 548.84,
    rx: 155.49,
    ry: 163.17
  }), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "565.92,495.75 559.65,494.29 511.63,496.45 517.81,523.65 537.49,511.96 560.34,526.19 566.29,499.07  "
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st12",
    cx: 714.27,
    cy: 547.06,
    rx: 149.5,
    ry: 150.46
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st12",
    cx: 365.39,
    cy: 547.02,
    rx: 149.5,
    ry: 150.46
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M856.31,562.63c2.88,1,9.6,1.32,12.53,0.96c2.25-0.28,4.65-1.11,6.19-3.95 c1.24-2.29,1.69-5.51,2.03-8.59c2.44-22.61,0.77-46.09,3.3-68.67c-8.76-1.16-17.55-1.77-25.98-1.87 c-1.43-0.63-8.64-0.76-9.32,0.77C836.68,500.05,856.31,562.63,856.31,562.63z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 228.82,
    y1: 472.98,
    x2: 210.77,
    y2: 551.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M222.38,563.53c-2.42,0.91-12.68,0.38-15.09-0.07c-1.85-0.34-3.8-1.25-4.97-4.13 c-0.94-2.33-1.2-5.56-1.36-8.64c-1.2-22.66,1.04-46.09-0.23-68.73c7.29-0.89,13.8-1.42,20.77-1.26 c1.21-0.59,15.41-1.39,15.92,0C244.41,499.96,222.38,563.53,222.38,563.53z"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Eye__x3E__10_",
    className: "st13",
    cx: 364.85,
    cy: 547.41,
    rx: 143.36,
    ry: 144.89
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Eye_lens_9_",
    className: "st13",
    cx: 712.95,
    cy: 547.41,
    rx: 143.36,
    ry: 144.89
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M514.9,530.96c5.01-16.81,25.51-20.73,35.54-13.48c4.96,3.58,10.77,6.75,14.29,16.51"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M511.63,497.79c11.33-8.19,26.37-10.39,39.97-7.28c6.08,1.39,12.21,3.98,16.08,8.91"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "521.25,580.96 503.64,625.62 566.41,619.63 553.1,582.32  "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M552.97,579.81l13.45,40.58l9.88-1.9l-13.45-35.69C562.85,582.79,557.41,577.26,552.97,579.81z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M498.29,625.19c14.88,21.3,28.36,43.75,40.28,67.11c16.12-23.58,30.34-48.68,42.43-74.92"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M514.9,580.46c2.66-3.52,10.22-6.54,14.36-8.01c1.98-0.7,4.1-0.83,6.2-0.91 c11.57-0.42,24.54,1.41,31.78,10.5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M868.84,563.6c0,163.8-147.02,296.59-328.37,296.59"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M540.47,860.19c-181.61,0-328.83-131.67-328.83-294.1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M400.09,297.56c-29.16-27.31-60.54-49.6-97.45-64.46c-12.92-5.57-27.69-9.29-38.76,0 c-5.54,5.57-11.07,13-11.07,20.43c-1.85,44.58,3.18,79.96,21.64,118.97c7.38,13,16.63,34.05,26.44,34.05"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M790.89,410.72c24.29-12.86,57.52-27.72,63.14-56.61c-15.65,3.78-26.33,4.07-42.1,7.34 c26.09-16.57,48.66-39.53,62.12-67.69c-12.71,5-24.84,11.35-37.47,16.54c10.7-27.58,18.08-61.02-0.37-87.02 c-9.23-9.29-22.15-5.57-33.22-1.86c-44.3,22.29-81.21,55.73-117.06,89.06"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M701.25,296.09c-5.44,3.73-7.57,11.61-13.73,13.95c-2.59,0.98-5.46,0.77-8.21,0.41 c-25.54-3.36-47.89-18.21-70.21-31.15s-47.43-24.65-71.32-18.44c29.96,6.1,57.05,25.28,70.89,52.49 c-28.24-18.46-61.96-27.39-95.6-28.96c-33.64-1.57-61.43,5.6-93.98,14.3c-7.07,1.89-15.98,3.36-20.49-2.43"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M813.9,262.81c21.86-9.62-13.89,4.7-21.93,15.97c-9.43,13.22-42.59,50.33-45.27,66.37 c-0.76,4.54-1.4,9.25-3.78,13.18c-5.12,8.45-16.29,10.47-26.11,10.95c-35.74,1.74-71.35-5.92-107.14-5.51 c-7.48,0.09-15.36,0.65-21.61,4.8c-10.21,6.78-14.21,21.89-25.96,25.31c-12.88,3.74-23.9-8.95-33.73-18.13 c-15.47-14.44-36.12-22.48-57.05-25.13c-20.93-2.66-42.22-0.22-62.85,4.24c-11.61,2.51-23.33,5.68-35.17,4.81 c-2.71-0.2-5.56-0.67-7.68-2.38c-2.35-1.89-3.4-4.92-4.39-7.78c-8.52-24.46-20.84-47.57-36.38-68.24 c-3.86-5.14-19.7-16.81-25.9-18.46c-19-5.03,22.48,6.63,25.36,18.47"
  }))))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 263.25,
    y: 283.18,
    className: "st1",
    width: 545,
    height: 518.64
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealOwlLogo);
export default __webpack_public_path__ + "static/media/realOwlLogo.74e20214374b3d3793f7199ebf898af5.svg";
export { ForwardRef as ReactComponent };